// ============================================================
// CombatFlowContext - in-flight combat state: pending attack /
// defence / reroll / bonus attack, the defence chain, and
// narrative operations. High frequency during combat resolution.
//
// State itself stays in DeathWatchSimulator's hooks; this context
// only distributes it (composition-root pattern).
// ============================================================
import { createContext, useContext } from 'react';

const CombatFlowContext = createContext(null);

export function CombatFlowProvider({ value, children }) {
  return <CombatFlowContext.Provider value={value}>{children}</CombatFlowContext.Provider>;
}

/**
 * Combat flow state + handlers:
 *   pendingAttack, pendingDefence, pendingReroll, handleRerollChoice,
 *   pendingBonusAttack, handleBonusAttackChoice,
 *   handleDefenceChoice, handleDefenceStep, acceptRemainingHits,
 *   defenceResolving, defenceChain, onGmForceClear, isDefencePending,
 *   firestoreNarrative, doClearNarrative, doCopyNarrative
 */
export function useCombatFlow() {
  const ctx = useContext(CombatFlowContext);
  if (!ctx) throw new Error('useCombatFlow must be used within a CombatFlowProvider');
  return ctx;
}
